<template>
  <b-container>
    <!--     <b-card>
      <b-form-radio-group v-model="synchronous" stacked>
        <b-form-radio :value="false">{{ $t('asynchronous') }}</b-form-radio>
        <b-form-group v-if="!synchronous" class="mt-2 ml-4" label="URL :">
          <b-form-input v-model="url" :disabled="changes_disabled" />
        </b-form-group>
        <b-form-radio :value="true">{{ $t('synchronous') }}</b-form-radio>
      </b-form-radio-group>
    </b-card> -->
    <b-form-group>
      <label>
        <b> {{ $t('table_chosen') }} </b>
      </label>
      <b-form-select v-model="table" :options="table_options" />
    </b-form-group>
    <b-form-group>
      <label>
        <b> {{ $t('endpoint') }} : </b>
      </label>
      <b-form-input v-model="endpoint" :disabled="changes_disabled" />
    </b-form-group>

    <b-form-group>
      <b-form-checkbox v-model="full_answer_path">
        <b> {{ $t('full_answer_path') }} </b>
      </b-form-checkbox>
    </b-form-group>
  </b-container>
</template>

<script>
import _ from 'lodash'

// import {
//   subscription_mixin,
//   brick_mixin,
//   brick_with_single_parent_mixin,
// } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'

import { BasicTableInfoEntity } from '@/components/object_model.js'

// *****************************************************************************

export default {
  name: 'BrickApiOutput',
  // mixins: [subscription_mixin, brick_mixin, brick_with_single_parent_mixin],
  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      table: -1,
      endpoint: '',
      full_answer_path: false,
    }
  },
  computed: {
    adapted_data() {
      let extended_table_info = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        extended_table_info.push(parent_info_entity_type)
      }

      let adapted = {
        uid: this.brick_id,
        parents_info: extended_table_info,
        endpoint: this.endpoint,
        full_answer_path: this.full_answer_path,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        this.table = (((new_val || {}).parents_info || [])[0] || {}).uid || -1
        this.endpoint = new_val.endpoint
        this.full_answer_path = new_val.full_answer_path
      },
    },
  },
}
</script>
